import React from 'react'
import { Checkbox, Space } from 'antd'
import PropTypes from 'prop-types'
import { useSmartTranslation } from '../../cls/TranslationContext'
/*
 * Features
 * @param {Object} features - The features object.
 * @param {Function} setFeatures - The function to set the features object.
 * @returns {JSX.Element} The features component.
 * Used to toggle features on and off. Returns a checkbox for each feature.
 * Could be used to controll what features are shown in a form. Controll what columns to be shown in a table or list.
 */
const Features = ({ features, setFeatures }) => {
	const { t } = useSmartTranslation()
	if (!features) return null

	return (
		<Space
			style={{ width: '100%' }}
			id="target-features"
			className="we-features"
		>
			{Object.keys(features).map((feature) => {
				const translationKey =
					'_' +
					(feature.endsWith('s') ? feature.slice(0, -1) : feature)

				return (
					<div key={feature} id={'target-features-' + feature}>
						<Checkbox
							checked={features[feature]}
							disabled={!setFeatures}
							onChange={(e) =>
								setFeatures &&
								setFeatures({
									...features,
									[feature]: e.target.checked
								})
							}
						>
							{t(translationKey)}
						</Checkbox>
					</div>
				)
			})}
		</Space>
	)
}
Features.propTypes = {
	features: PropTypes.object.isRequired,
	setFeatures: PropTypes.func
}

export default Features

/**
* Features
* Example use:
	const [features, setFeatures] = React.useState({
		recurrence: _itm.recurrence.type !== 'deadline',
		subtasks: toJS(_itm.subtasks.list)?.length > 0,
		comments: toJS(_itm.comments.list)?.length > 0
	})

	const onFeaturesChange = (features) => {
		if (!features.recurrence) {
			form.setFieldsValue({
				recurrenceType: 'deadline',
				recurrenceStartEnd: [],
				recurrenceMonthsTrack: [],
				recurrenceDaysOfWeek: [],
				recurrenceDaysOfMonth: [],
				recurrenceMonths: [],
				recurrenceTimes: []
			})
		}
		if (!features.subtasks) {
			form.setFieldsValue({
				subtasks: []
			})
		}
		if (!features.comments) {
			form.setFieldsValue({
				comments: []
			})
		}
	}
	<Features
		features={features}
		setFeatures={(val) => {
			setFeatures(val)
			onFeaturesChange(val)
		}}
	/>
*/
